import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, Row, Col } from 'react-bootstrap';

const GoCardlessDirectDebit = () => {
  const [formData, setFormData] = useState({
    customerName: '',
    customerEmail: '',
    customerPhone: '',
    companyName: ''
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      // First, create a customer record in our system
      const response = await fetch('/api/gocardless/create-customer', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        // Redirect to GoCardless Direct Debit setup with success redirect
        const successUrl = `${window.location.origin}/gocardless-success?customer_email=${encodeURIComponent(formData.customerEmail)}`;
        window.location.href = `https://pay.gocardless.com/BRT0003W7REYQFN?customer_email=${encodeURIComponent(formData.customerEmail)}&customer_name=${encodeURIComponent(formData.customerName)}&success_redirect_flow_id=${encodeURIComponent(successUrl)}`;
      } else {
        setStatus({ type: 'danger', message: data.error || 'Failed to create customer account' });
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus({ type: 'danger', message: 'An error occurred. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow">
            <Card.Header className="bg-primary text-white text-center">
              <h3 className="mb-0">Set Up Direct Debit</h3>
            </Card.Header>
            <Card.Body className="p-4">
              <div className="text-center mb-4">
                <h5>New Customer Direct Debit Setup</h5>
                <p className="text-muted">
                  Set up a Direct Debit for convenient automatic payments. 
                  We'll create your account and send you login instructions.
                </p>
              </div>

              {status && (
                <Alert variant={status.type} dismissible onClose={() => setStatus(null)}>
                  {status.message}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Full Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="customerName"
                    value={formData.customerName}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter your full name"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email Address *</Form.Label>
                  <Form.Control
                    type="email"
                    name="customerEmail"
                    value={formData.customerEmail}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter your email address"
                  />
                  <Form.Text className="text-muted">
                    We'll send your login instructions to this email
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Phone Number *</Form.Label>
                  <Form.Control
                    type="tel"
                    name="customerPhone"
                    value={formData.customerPhone}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter your phone number"
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Company Name (Optional)</Form.Label>
                  <Form.Control
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleInputChange}
                    placeholder="Enter your company name if applicable"
                  />
                </Form.Group>

                <div className="d-grid">
                  <Button
                    type="submit"
                    variant="success"
                    size="lg"
                    disabled={loading}
                  >
                    {loading ? 'Setting up...' : 'Set Up Direct Debit'}
                  </Button>
                </div>
              </Form>

              <div className="mt-4 p-3 bg-light rounded">
                <h6 className="mb-2">What happens next?</h6>
                <ol className="mb-0 small">
                  <li>We'll create your customer account</li>
                  <li>You'll be redirected to GoCardless to set up your Direct Debit</li>
                  <li>Once setup is complete, you'll receive an email with login instructions</li>
                  <li>You can then log in and set your password</li>
                </ol>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default GoCardlessDirectDebit; 